import { Plus, Pencil, Check } from 'lucide-react'
import type { StakeholderTemplate } from '@bandos/shared'
import { MAX_TEAM_SIZE } from '../CharacterSelectionModal.types'
import { PortraitDisplay } from './PortraitDisplay'
import {
  CharacterCard,
  CardInTeamOverlay,
  CardActionsOverlay,
  CardActionButton,
  CardContent,
  CardName,
  CardRole,
} from '../styles/CharacterSelectionModalStyles'

interface TemplateCardProps {
  template: StakeholderTemplate
  isInTeam: boolean
  isTeamFull: boolean
  isSelected: boolean
  isOperating: boolean
  isGenerating: boolean
  teamSize: number
  brokenPortraits: Set<string>
  markPortraitBroken: (id: string) => void
  onSelect: (template: StakeholderTemplate) => void
  onEdit: (template: StakeholderTemplate, e: React.MouseEvent) => void
  onAddToTeam: (template: StakeholderTemplate, e: React.MouseEvent) => void
}

export function TemplateCard({
  template,
  isInTeam,
  isTeamFull,
  isSelected,
  isOperating,
  isGenerating,
  teamSize,
  brokenPortraits,
  markPortraitBroken,
  onSelect,
  onEdit,
  onAddToTeam,
}: TemplateCardProps) {
  return (
    <CharacterCard
      $isInTeam={isInTeam}
      $isTeamFull={isTeamFull}
      $isSelected={isSelected}
      onClick={() => onSelect(template)}
    >
      <PortraitDisplay
        template={template}
        size="card"
        brokenPortraits={brokenPortraits}
        markPortraitBroken={markPortraitBroken}
        isGenerating={isGenerating}
      />
      {isInTeam && (
        <CardInTeamOverlay>
          <Check size={24} />
        </CardInTeamOverlay>
      )}
      {!isInTeam && (
        <CardActionsOverlay>
          <CardActionButton onClick={(e) => onEdit(template, e)}>
            <Pencil size={12} />
            Edit
          </CardActionButton>
          <CardActionButton
            $variant="primary"
            onClick={(e) => void onAddToTeam(template, e)}
            disabled={isOperating || teamSize >= MAX_TEAM_SIZE}
          >
            <Plus size={12} />
            Add
          </CardActionButton>
        </CardActionsOverlay>
      )}
      <CardContent>
        <CardName>{template.name}</CardName>
        {template.role && <CardRole>{template.role}</CardRole>}
      </CardContent>
    </CharacterCard>
  )
}
